// extracted by mini-css-extract-plugin
module.exports = {"btn":"CommandActionButton_btn__1Y7E4","icon":"CommandActionButton_icon__2be84"};